<form [formGroup]="targetForm">
    <section class="sideRight-body reason-container">
        <div class="reason-row" *ngFor="let reason of reasons">
            <div class="submitted-by">{{reason.submittedBy}}</div>
            <div class="submitted-time">{{reason.submittedOn | tolocaldate}}</div>
            <div *ngIf="reason.isInternal == true" class="reason">
                <p>
                    <b>Remarks: </b> {{reason.reason}}
                </p>
            </div>        
        </div>
    </section>
</form>
